<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Registrierungsprozesse</mat-card-title>
    <mat-card-content>
      <div>
        Registrierung, Normalfall:
        <ul>
          <li><em>Created</em> - Die Daten wurden über das Registrierungsformular erfasst</li>
          <li><em>Onboarded</em> - Die Daten wurden an MNET erfolgreich ermittelt</li>
          <li><em class="done">Done</em> - Der Benutzer wurde durch den E-Serviceantrag erfolgreich importiert, ein Login ist jetzt möglich</li>
        </ul>
        Registrierung, Fehlerfall:
        <ul>
          <li><em class="conflict">Conflict</em> - Die Daten wurden von MNET aufgrund des Dublettenchecks zurückgewiesen</li>
        </ul>
      </div>

      <div class="filters">
        <form [formGroup]="form">
          <mat-form-field appearance="fill">
            <input class="search" type="text" matInput placeholder="Suche" formControlName="text" />
          </mat-form-field>
        </form>
      </div>

      <table mat-table #table [dataSource]="entries$" matSort>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="created">Datum</th>
          <td mat-cell *matCellDef="let r">
            {{ r.created | moment }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lastname">Name</th>
          <td mat-cell *matCellDef="let r">{{ r.firstName }} {{ r.lastName }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email">E-Mail</th>
          <td mat-cell *matCellDef="let r">
            {{ r.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="startupName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Startup</th>
          <td mat-cell *matCellDef="let r">
            {{ r.startupName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="zipcode">Adresse</th>
          <td mat-cell *matCellDef="let r" class="addressCell">
            {{ r.street }}
            <div>{{ r.zipCode }} {{ r.city }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
          <td mat-cell *matCellDef="let r" style="text-align: right">
            <em [ngStyle]="{color: statusToColor(r.status)}">
              {{ r.status }}
              <i [class]="'far ' + statusToIcon(r.status)"></i>
            </em>
          </td>
        </ng-container>
      </table>
      <mat-paginator #paginator [length]="(response$ | async)?.total" [pageSize]="25" [pageSizeOptions]="[25, 100, 1000]"></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
